import { ky } from './ky';
import { ExistResponse, ListResponse } from './common';
import { AccountDto } from './account';

export interface FeedCommentDto {
  id?: number;
  account?: AccountDto;
  content?: string;
  createdAt?: string;
  createdFrom?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedFrom?: string;
  updatedBy?: string;
}

export interface CommentQueryParams {
  pivot?: any; // 기준 필드 데이터
  order: 'ASC' | 'DESC'; // 정렬
  field: string; // 필드 이름
  size: number; // 불러올 데이터 개수
}

export interface CreateCommentDto {
  content: string;
}

export default class FeedCommentService {

  /**
   * 피드 피드 댓글 조회
   *
   * @param feedId 피드 ID
   */
  async getFeedComments(feedId: string) {
    return await ky.get(`v1/feeds/${feedId}/comments`).json() as ListResponse<FeedCommentDto>;
  }

  /**
   * 피드 댓글 페이지네이션 조회
   *
   * @param feedId 피드 ID
   * @param params 쿼리 파라미터
   */
  async getFeedCommentsWithPagination(feedId: string, params: CommentQueryParams) {
    const searchParams = new URLSearchParams();

    if (params.pivot !== undefined) {
      searchParams.append('pivot', String(params.pivot));
    }
    searchParams.append('order', params.order);
    searchParams.append('field', params.field);
    searchParams.append('size', String(params.size));

    return await ky.get(`v1/feeds/${feedId}/comments?${searchParams.toString()}`).json() as ListResponse<FeedCommentDto>;
  }

  /**
   * 댓글 작성
   *
   * @param feedId
   * @param comment
   */
  async write(feedId: string, comment: CreateCommentDto) {
    await ky.post(`v1/feeds/${feedId}/comments`, {
      json: comment
  });
  }

  /**
   * 댓글 수정
   *
   * @param feedId
   * @param comment
   */
  async update(feedId: string, comment: FeedCommentDto) {
    await ky.put(`v1/feeds/${feedId}/comments/${comment.id}`, {
      json: comment
    });
  }

  /**
   * 댓글 삭제
   *
   * @param feedId
   * @param commentId
   */
  async delete(feedId: string, commentId: number) {
    await ky.delete(`v1/feeds/${feedId}/comments/${commentId}`);
  }

}
